/**
 * UUID string format (any version). Single source of truth for validating
 * organization / account / category IDs before they are used in schema names
 * or interpolated into query filters.
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** True when `value` is a well-formed UUID string. */
export function isUuid(value: string): boolean {
  return UUID_REGEX.test(value)
}

/**
 * Legacy Plaid category key format: UPPER_SNAKE, must start with a letter
 * (e.g. FOOD_AND_DRINK). Single source of truth for both URL-param validation
 * and the db-tenant filter charset guard so the two can't drift.
 */
export const PLAID_CATEGORY_REGEX = /^[A-Z][A-Z_]*$/

export function isValidDate(dateString: string): boolean {
  const date = new Date(dateString)
  return !isNaN(date.getTime())
}

export function isPositiveNumber(value: string | number | null | undefined): value is number {
  return typeof value === 'number' && !isNaN(value) && value > 0
}

export function isNonEmptyString(value: string | null | undefined): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

export function validateGLAccount(account: string): boolean {
  // Basic GL account validation - adjust pattern based on your requirements
  const glAccountRegex = /^\d{4,10}(-\d{2,4})?$/
  return glAccountRegex.test(account)
}

export function validateAmount(amount: number): { valid: boolean; error?: string } {
  if (typeof amount !== 'number' || isNaN(amount)) {
    return { valid: false, error: 'Amount must be a valid number' }
  }
  if (amount === 0) {
    return { valid: false, error: 'Amount cannot be zero' }
  }
  return { valid: true }
}